// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_FileStorePage__TDGOX{
    width: 100%;
    overflow: auto;
    align-items: center;
}
.styles_ListContainer__gmY4v{
    min-width: min-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}
.styles_ControlPanel__B8DnZ{
    padding: 20px;;
    display: flex;
    justify-content: start;
}

.styles_ControlPanel__B8DnZ > *{
     margin-left: 20px;
}

.styles_TableContainer__N1xA5 {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.styles_TableContainer__N1xA5 > * {
    max-width: 1200px;
}

.styles_FilesContainer__oWrm- {
    background-color: white;
    width: 600px;
    min-height: 400px;
    height: max-content;
    padding: 20px;
    border-radius: 12px;

    display: flex;
    flex-direction: column;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/DocsListPage/styles.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;KACK,iBAAiB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".FileStorePage{\n    width: 100%;\n    overflow: auto;\n    align-items: center;\n}\n.ListContainer{\n    min-width: min-content;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n}\n.ControlPanel{\n    padding: 20px;;\n    display: flex;\n    justify-content: start;\n}\n\n.ControlPanel > *{\n     margin-left: 20px;\n}\n\n.TableContainer {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.TableContainer > * {\n    max-width: 1200px;\n}\n\n.FilesContainer {\n    background-color: white;\n    width: 600px;\n    min-height: 400px;\n    height: max-content;\n    padding: 20px;\n    border-radius: 12px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FileStorePage": `styles_FileStorePage__TDGOX`,
	"ListContainer": `styles_ListContainer__gmY4v`,
	"ControlPanel": `styles_ControlPanel__B8DnZ`,
	"TableContainer": `styles_TableContainer__N1xA5`,
	"FilesContainer": `styles_FilesContainer__oWrm-`
};
export default ___CSS_LOADER_EXPORT___;
